import React from "react";

import ConfirmationsModal from "@/components/molecules/quote-section/edit-quote-section/confirmation-modal";
import { useFetchValidateMedicalsWarning } from "@/hooks/magnolia/use-fetch-validate-medicals-warning";

type ValidateMedicalsWarningMessageProps = {
  isOpen: boolean;
  onContinueClick: () => void;
  setIsOpen: (isOpen: boolean) => void;
};

function ValidateMedicalsWarningMessage({
  isOpen,
  onContinueClick,
  setIsOpen,
}: Readonly<ValidateMedicalsWarningMessageProps>) {
  const { data: warningMessage } = useFetchValidateMedicalsWarning();

  return (
    <ConfirmationsModal
      modalTitle={warningMessage.modalTitle || ""}
      modalDescription={warningMessage.modalDescription ?? ""}
      backButtonLabel={warningMessage.backButtonLabel || ""}
      ctaButtonLabel={warningMessage.ctaButtonLabel || ""}
      handleConfirmBtnClick={onContinueClick}
      handleCancelmBtnClick={() => {
        setIsOpen(false);
      }}
      isOpen={isOpen}
      isShowDescription
    />
  );
}

export default ValidateMedicalsWarningMessage;
